import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import locales from "./locales/index";
i18n.use(LanguageDetector).init({
  debug: true,
  lng: JSON.parse(localStorage.getItem("@shelter_language"))
    ? JSON.parse(localStorage.getItem("@shelter_language"))
    : "en",
  resources: {
    es: {
      common: locales.es
    },
    en: {
      common: locales.en
    }
  },

  fallbackLng: "en",

  ns: ["common"],

  defaultNS: "common",

  react: {
    wait: false,
    bindI18n: "languageChanged loaded",
    bindStore: "added removed",
    nsMode: "default"
  }
});

export default i18n;
